import { FC, HTMLAttributes, ReactNode } from 'react';

interface LLHeadingProps {
  tagName: '1' | '2' | '3' | '4' | '5' | '6';
  className?: '1' | '2' | '3' | '4 ' | '5' | '6' | '7';
  children: ReactNode;
  customClass?: string;
}

const LLHeading: FC<HTMLAttributes<HTMLHeadingElement> & LLHeadingProps> = ({
  tagName,
  className,
  children,
  customClass,
}) => {
  const Tag = `h${tagName}` as keyof React.JSX.IntrinsicElements;
  const cssClass = className ? `h${className}` : Tag;
  return <Tag className={`${cssClass} ${customClass}`}>{children}</Tag>;
};

export default LLHeading;
